import React from 'react';
import clsx from 'clsx';

import styles from './component.module.scss';

const TableCell = ({
  header,
  style,
  alignment,
  children
}: {
  header?: boolean;
  style?: 'normal' | 'link';
  alignment?: 'left' | 'right' | 'center';
  children?: React.ReactNode;
}) => {
  const CellComponent = header ? 'th' : 'td';

  return (
    <CellComponent
      className={clsx(
        styles.main,
        styles[style ?? 'normal'],
        styles[alignment ?? 'left']
      )}
    >
      {children}
    </CellComponent>
  );
};

export { TableCell };
